import type {
  TDocumentoAnexado,
  TDocumentoEnviado,
  TDocumentoPersistido,
  TDocumentoRetornado,
  TDocumentosPessoa,
} from '../types'

const documentoComIdentificador = (documento: TDocumentoRetornado): documento is TDocumentoPersistido =>
  'documentoId' in documento

const criarDocumentoPersistido = ({
  documentoId,
  tipoDeDocumento,
  dataEnvio,
}: TDocumentoPersistido): TDocumentoAnexado => ({
  id: documentoId,
  tipo: tipoDeDocumento,
  dataEnvio,
  status: 'success',
})

const criarDocumentoRecuperado = ({ dataEnvio, tipo }: TDocumentoEnviado): TDocumentoAnexado => ({
  id: `${dataEnvio}-${tipo}`,
  status: 'recovered',
  tipo,
  dataEnvio,
})

export const selectRecuperarDocumentos = (data: TDocumentosPessoa): TDocumentoAnexado[] =>
  data?.documentos?.map((documento) =>
    documentoComIdentificador(documento) ? criarDocumentoPersistido(documento) : criarDocumentoRecuperado(documento),
  ) || []
